import React, {memo} from 'react';
import {ModuleTabularPage} from "../../components";
import {AdminModules, AdminReqUrls} from "../../config/AdminConfig";

const GroupsPage = memo(() => {
    return (<ModuleTabularPage
        moduleName={AdminModules.Groups}
        fetchRecordsUrl={AdminReqUrls.admin__groups__mainPage_fetch_recordList}
    />)
});
export default GroupsPage;
